import React from "react";
import { LANDING_MENU_BAR } from "./../../constants/strings/StringsDashboard";
// import CityTurbo from "./../../images/Turbo.png";
// import CityVillavicencio from "./../../images/Villavicencio.png";
// import CityApartado from "./../../images/Apartado.png";
import Comuna01 from "./../../images/comunas/Comuna01.png";
import Comuna02 from "./../../images/comunas/Comuna02.png";
import Comuna03 from "./../../images/comunas/Comuna03.png";
import Comuna04 from "./../../images/comunas/Comuna04.png";
import Comuna05 from "./../../images/comunas/Comuna05.png";
import Comuna06 from "./../../images/comunas/Comuna06.png";
import Comuna07 from "./../../images/comunas/Comuna07.png";
import Comuna08 from "./../../images/comunas/Comuna08.png";
import Comuna09 from "./../../images/comunas/Comuna08.png";
import Comuna10 from "./../../images/comunas/Comuna08.png";
import Corregimiento01 from "./../../images/comunas/Comuna08.png";
import Corregimiento02 from "./../../images/comunas/Comuna08.png";
import Corregimiento03 from "./../../images/comunas/Comuna08.png";
import Corregimiento04 from "./../../images/comunas/Comuna08.png";
import Corregimiento05 from "./../../images/comunas/Comuna08.png";
import Corregimiento06 from "./../../images/comunas/Comuna08.png";
import Corregimiento07 from "./../../images/comunas/Comuna08.png";
import Button from "@material-ui/core/Button";
// import EXTORSION from "./../../images/icons/fenomenes/f-ext.svg";
// import COMISARIA from "./../../images/icons/communal-file/ComisariaFamilia.svg";
// import NOCOMISARIA from "./../../images/icons/communal-file/NOComisariaFamilia.svg";
// import INSPECCION from "./../../images/icons/communal-file/InspeccionPolicia.svg";
// import NOINSPECCION from "./../../images/icons/communal-file/NOInspeccionPolicia.svg";
// import CASAJUSTICIA from "./../../images/icons/communal-file/CasaJusticia.svg";
// import NOCASAJUSTICIA from "./../../images/icons/communal-file/NOCasaJusticia.svg";
// import CAMARAS from "./../../images/icons/communal-file/Camaras.svg";
// import INSTALCAMARAS from "./../../images/icons/communal-file/InstalacionCamaras.svg";
// import NOCAMARAS from "./../../images/icons/communal-file/NOCamaras.svg";
// import CENTROMONITOREO from "./../../images/icons/communal-file/CentroMonitoreo.svg";
// import NOCENTROMONITOREO from "./../../images/icons/communal-file/NOCentroMonitoreo.svg";
// import ALARMACOMUNITARIA from "./../../images/icons/communal-file/AlarmaComunitaria.svg";
// import NOALARMACOMUNITARIA from "./../../images/icons/communal-file/NOAlarmaComunitaria.svg";

import Granada from "./../../images/cities/2021/ALCALDIA-80px.png";
// import Granada from "./../../images/cities/2020/villavicencio.png";

function getComuna(comuna) {
  switch (comuna) {
    case "Granada":
      return Granada;
    case "Comuna 1":
      return Comuna01;
    case "Comuna 2":
      return Comuna02;
    case "Comuna 3":
      return Comuna03;
    case "Comuna 4":
      return Comuna04;
    case "Comuna 5":
      return Comuna05;
    case "Comuna 6":
      return Comuna06;
    case "Comuna 7":
      return Comuna07;
    case "Comuna 8":
      return Comuna08;
    case "Comuna 9":
      return Comuna09;
    case "Comuna 10":
      return Comuna10;
    case "Corregimiento 1":
      return Corregimiento01;
    case "Corregimiento 2":
      return Corregimiento02;
    case "Corregimiento 3":
      return Corregimiento03;
    case "Corregimiento 4":
      return Corregimiento04;
    case "Corregimiento 5":
      return Corregimiento05;
    case "Corregimiento 6":
      return Corregimiento06;
    case "Corregimiento 7":
      return Corregimiento07;
    default:
      return Granada;
  }
}
function getIcon(hay, type) {
  switch (type) {
    // case "CasaJusticia": {
    //   return hay.toLowerCase() === "si" ? CASAJUSTICIA : NOCASAJUSTICIA;
    // }
    // case "ComisariaFamilia": {
    //   return hay.toLowerCase() === "si" ? COMISARIA : NOCOMISARIA;
    // }
    // case "InspeccionPolicia": {
    //   return hay.toLowerCase() === "si" ? INSPECCION : NOINSPECCION;
    // }
    // case "CentroMonitoreo": {
    //   return hay.toLowerCase() === "si" ? CENTROMONITOREO : NOCENTROMONITOREO;
    // }

    default:
      return console.log("NADA");
  }
}

function FichaComponent({ data, handlerSubmit, onClose }) {
  console.log(data);
  return (
    <>
      <div>
        <div className="page-title" style={{ fontWeight: "bold" }}>
          {LANDING_MENU_BAR.COMMUNAL_FILE}
        </div>
      </div>
      <div style={{ textAlign: "-webkit-center"}}>
        <div className="work-sheet-communal-file" id="work-sheet-communal-file">
          <div className="line line-100">
            <div>
              <div className="page-title-city-card line line-100">
                <div className="line line-100 text-center">
                  <span>Ficha Comunal {data.nombre}</span>
                </div>
              </div>
            </div>
            <div className="line line-33" style={{ float: "left" }}>
              <div className="page-subtitle-img-city-card">DATOS GENERALES</div>

              <h1 className="page-text-city-card">Población actual:</h1>
              <div className="text-subtitle-city-card">
                {data.poblacion} Habitantes
              </div>
              <h1 className="page-text-city-card">
                Población con respecto a Granada:
              </h1>
              <div className="text-subtitle-city-card">{data.poblacion} %</div>
              <h1 className="page-text-city-card">Puesto población:</h1>
              <div className="text-subtitle-city-card">N° {data.categoria}</div>
              <h1 className="page-text-city-card">Área total en Km2:</h1>
              <div className="text-subtitle-city-card">{data.area}</div>
              <h1 className="page-text-city-card">
                Área respecto a Granada:
              </h1>
              <div className="text-subtitle-city-card">{data.areaUrbana} %</div>
              <h1 className="page-text-city-card">Puesto Área:</h1>
              <div className="text-subtitle-city-card">{data.areaRural}</div>
              <h1 className="page-text-city-card">Número de Barrios:</h1>
              <div className="text-subtitle-city-card">{data.numBarrios}</div>
              <div className="page-subtitle-city-card line-city-card line-100">
                Institucionalidad en Seguridad y Convivencia
              </div>

              <div className="line line-90 title-text-communal-file">
                La Comuna tiene elaborado plan comunal de Seguridad y
                Convivencia Ciudadana (PISCC):
              </div>

              <div className="line-city-card line-100 page-text-city-card">
                Casa de Justicia:
              </div>
              <div className="line-city-card line-100 result-subtitle-communal-file">
                <img
                  src={getIcon(data.hayCasasJusticia, "CasaJusticia")}
                  className="icon-communal-file"
                  alt="Casa de Justicia"
                />
                {data.hayCasasJusticia}
              </div>
              <div className="line-city-card line-100 page-text-city-card">
                Comisaría de Familia
              </div>
              <div className="line-city-card line-100 result-subtitle-communal-file">
                <img
                  src={getIcon(data.hayComisarias, "ComisariaFamilia")}
                  className="icon-communal-file"
                  alt="Comisaría de Familia"
                />
                {data.hayComisarias}
              </div>
              <div className="line-city-card line-100 page-text-city-card">
                Inspección de Policía
              </div>

              <div className="line-city-card line-100 result-subtitle-communal-file">
                <img
                  src={getIcon(data.hayInspeccionPolicia, "InspeccionPolicia")}
                  className="icon-communal-file"
                  alt="Inspección de Policia"
                />
                {data.hayInspeccionPolicia}
              </div>
            </div>
            <div className="line line-66">
              <div>
                <img
                  className="page-title-img-city-card"
                  src={getComuna(data.nombre)}
                  alt={data.nombre}
                ></img>

                <div className="line-city-card line-50 page-text-city-card"></div>
              </div>
              <div>
                <div className="page-subtitle-city-card line-city-card line-100">
                  Tecnología en Seguridad y Convivencia
                </div>
                <div className="line-city-card line-50 page-text-city-card">
                  Tiene Centro de monitoreo de Cámaras o salas CIEPS:
                </div>

                <div className="line-city-card line-50 page-text-city-card">
                  Número de Cámaras de Videovigilancia en funcionamiento
                  actualmente:
                </div>
                <div className="line-city-card line-50 result-subtitle-communal-file">
                  <img
                    src={getIcon(data.hayCctv, "CentroMonitoreo")}
                    className="icon-communal-file"
                    alt="Centro de Monitoreo"
                  />
                  {data.hayCctv}
                </div>
                <div className="line-city-card line-50 result-subtitle-communal-file">
                  {/* <img
                    src={CAMARAS}
                    className="icon-communal-file"
                    alt="Camaras en Funcionamiento"
                  /> */}
                  {data.numCamarasFuncionamiento}
                </div>
                <div className="line-city-card line-50 page-text-city-card">
                  Número de Cámaras proyectadas para la vigencia:{" "}
                </div>
                <div className="line-city-card line-50 page-text-city-card">
                  Número de Alarmas Comunitarias en Funcionamiento:
                </div>
                <div className="line-city-card line-50 result-subtitle-communal-file">
                  {/* <img
                    src={INSTALCAMARAS}
                    className="icon-communal-file"
                    alt="Casa de Justicia"
                  /> */}
                  {data.numCamarasProyectadas}
                </div>
                <div className="line-city-card line-50 result-subtitle-communal-file">
                  {/* <img
                    src={ALARMACOMUNITARIA}
                    className="icon-communal-file"
                    alt="Comisaría de Familia"
                  /> */}
                  {data.numAlarmas}
                </div>
              </div>
              <div>
                <div className="page-subtitle-city-card line-city-card line-100">
                  Policía Nacional
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Estación de Policía Encargada:
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Rango y Nombre del Comandante de estación: {data.comandante}
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Número de cuadrantes de Policía en la comuna:{" "}
                  {data.numPolicias}
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Número de CAI de Policía en la comuna: {data.numCais}
                </div>
              </div>
              <div>
                <div className="page-subtitle-city-card line-city-card line-100 line-city-card line-100">
                  Perfil básico de Seguridad y Orden Público
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Descripción de la seguridad y orden público en el municipio:{" "}
                  {data.descSegyOrdenPublico}
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Hay Grupos Armados Organizados (GAO): {data.hayGao}
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100">
                  Hay Grupos Delictivos Organizados (GDO): {data.hayGdo}
                </div>
                <div className="title-text-communal-file-3 line-city-card line-100 communal-description">
                  DECRIPCION
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="button-div-change-password">
        <Button
          variant="contained"
          onClick={handlerSubmit}
          color="secondary"
          className="boton-capital boton-guardar-password"
        >
          Guardar
        </Button>
        <Button
          variant="contained"
          onClick={onClose}
          color="primary"
          className="boton-capital boton-cancelar-password"
        >
          Cancelar
        </Button>
      </div>
    </>
  );
}

export default FichaComponent;
